// frontend/src/farm/batcher.mjs
// Collects optimistic ops and decides when to send them (spec §3: every second, at 10 ops,
// or when the queue goes idle). Pure (node --test); the scene owns the timer and the send.

export function createBatcher({ maxOps = 10, maxWaitMs = 1000 } = {}) {
  return { maxOps, maxWaitMs, list: [], firstAt: null };
}

export function push(b, op, nowMs) {
  if (b.list.length === 0) b.firstAt = nowMs;
  b.list.push(op);
}

export function shouldFlush(b, nowMs, { idle = false } = {}) {
  if (b.list.length === 0) return false;
  if (b.list.length >= b.maxOps || idle) return true;
  return nowMs - b.firstAt >= b.maxWaitMs;
}

export function take(b) {
  const ops = b.list;
  b.list = [];
  b.firstAt = null;
  return ops;
}

export function pending(b) { return [...b.list]; }
